<template>
    <transition name="appDialog">
        <div class="appDialog">
            <div class="wrapper">
                <div class="outer">
                    <div class="holder">
                        <div class="innerWrapper">
                            <div class="overflow-hidden mb-8">
                                <div
                                    v-click-outside="() => closeClickOutside ? close() : null"
                                    :class="{'isFullWidth': fullWidth}"
                                    class="innerDialog"
                                >
                                    <button
                                        type="button"
                                        name="button"
                                        class="closeButton"
                                        @click="$emit('close')"
                                    >
                                        <svg slot="icon" svg-inline="" class="closeIcon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                                    </button>
                                    <slot/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        closeClickOutside: {
            type: Boolean,
            default: true,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        isLocked: true,
    }),
    created() {
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.keyListener);

        setTimeout(() => {
            this.isLocked = false;
        }, 250);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.keyListener);
        document.body.classList.remove('overflow-hidden');
    },
    methods: {
        keyListener(event) {
            if (event.keyCode === 27) {
                this.close();
            }
        },
        close() {
            if (!this.isLocked) {
                this.$emit('close');
            }
        },
    },
};
</script>

<style lang="postcss" scoped>
.appDialog-enter-active,
.appDialog-leave-active {
    transition: opacity 0.35s;
}
.appDialog-enter,
.appDialog-leave-to {
    opacity: 0;
}
.appDialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;
    overflow: auto;
    padding: 0 15px;
    -webkit-overflow-scrolling: touch;
}
.wrapper {
    width: 100%;
    height: calc(100% - 60px);
    display: flex;
    align-items: center;
    flex-direction: row;
    margin: 30px 0;
}
.outer {
    margin: auto;
    display: flex;
    width: 100%;
    max-height: 100%;
}
.holder {
    width: 100%;
    margin: 0 auto;
    max-width: 100%;
}
.innerWrapper {
    max-width: 100%;
    margin: 0 auto;
    padding-bottom: 30px;
}
.innerDialog {
    background-color: #fff;
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
    padding: 25px;
    border-radius: var(--borderRadius);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.22), 0 13px 16px rgba(0, 0, 0, 0.2);
    position: relative;
    &.isFullWidth {
        width: 100%;
        padding: 50px;
    }
}
.closeButton {
    position: absolute;
    right: 12px;
    top: 15px;
    width: 20px;
    height: 20px;
}
</style>
